import { Box, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

import Button from "../../components/Atoms/Button";
import { Colors } from "../../constants/Colors";

const GRADIENT = `linear-gradient(95.5deg, ${Colors.Button.main.left} 5.99%, ${Colors.Button.main.right} 100%)`;

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        px: 4,
        bgcolor: Colors.Background,
      }}
    >
      <Typography
        sx={{
          fontSize: { xs: "72px", sm: "96px" },
          fontWeight: 700,
          lineHeight: 1,
          mb: 2,
          background: GRADIENT,
          backgroundClip: "text",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }}
      >
        404
      </Typography>
      <Typography variant="h5" fontWeight={700} color={Colors.Text.main}>
        ページが見つかりません
      </Typography>
      <Box
        sx={{
          width: 40,
          height: 3,
          background: GRADIENT,
          borderRadius: 1,
          my: 3,
        }}
      />
      <Typography variant="body2" color={Colors.Label}>
        アクセスしたページは存在しないか、
        <br />
        移動・削除された可能性があります。
      </Typography>
      <Box sx={{ mt: 5 }}>
        <Button label="提案ページに戻る" size="large" onClick={() => navigate("/users")} />
      </Box>
    </Box>
  );
};

export default NotFound;
